module.exports = __webpack_public_path__ + "img/md-layer.dac9212f.png";